import $api from "../http"

export default class ProductService {
    static async getAll(options = {}) {
        const {limit = 12, page = 1, filters = {}, min = '', max = '', sort, exception, ids, search, rand, withImage, available, discounted} = options

        return $api.get('/api/products', {
            params: {limit, page, filters, min, max, sort, exception, ids, search, rand, withImage, available, discounted}
        })
    }

    static async getOne(id) {
        return $api.get('/api/products/' + id)
    }
}